import React from 'react';
import PropTypes from 'prop-types';
import "./styles.css"

export default class RadioLikertScale extends React.Component {
  constructor(props) {
    super(props)
  }


  perc(n) {
    return (n * 100).toFixed(2) + "%"
  }

  render() {
    var inputs = []
    for (let i = 0; i < this.props.intervals; i++) {
      inputs.push(
        <input
          className="likert-radio-button"
          type="radio"
          value={i+1}
          name="a"
          key={"radioslider-radio-" + i}
          checked={this.props.value == i}
          onChange={()=>{this.props.onChange(i)}}
          style={{'--radio-width': this.perc(1 / this.props.intervals)}}
          aria-label={this.props.labels ? this.props.labels[i] : i + 1}
        />
      )
    }
  	return (
      <div style={{height: '24px', margin: '10px 0px 10px 0px'}}>
        <form>
          <fieldset>
            <legend className="sr-only">{this.props.legend}</legend>
            <div className="likert-radio-bar form-group" role="radiogroup" style={{'--progress': this.perc(this.props.value / (this.props.intervals - 1)), '--radio-width': this.perc(1 / this.props.intervals)}}>
              {inputs}
            </div>
          </fieldset>
        </form>
      </div>
  	)
  }

}
